import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Backward = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.35 25.064C41.35 35.74 32.673 44.42 22 44.42c-10.672 0-19.35-8.68-19.35-19.356 0-5.587 2.394-10.676 6.284-14.268.4-.299.998-.299 1.297.1.299.4.299.998 0 1.297-3.491 3.193-5.686 7.783-5.686 12.87 0 9.679 7.88 17.561 17.555 17.561s17.555-7.882 17.555-17.56c-.1-9.678-7.98-17.56-17.655-17.56h-.399l3.591 3.592c.4.399.4.898 0 1.297-.399.399-.898.399-1.297 0L18.71 7.204c-.2-.199-.3-.399-.3-.698 0-.3.1-.499.3-.599L23.895.72c.4-.399.898-.399 1.297 0 .4.4.4.898 0 1.297l-3.59 3.592H22c10.673.1 19.35 8.78 19.35 19.456Z"
  }));
});
Backward.displayName = 'Backward';
Backward.defaultProps = {
  'aria-label': 'Backward'
};
export default Backward;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Backward.js
// module id = 3099
// module chunks = 11